var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60225 6.35225C8.82192 6.13258 9.17808 6.13258 9.39775 6.35225L13.8977 10.8523C14.1174 11.0719 14.1174 11.4281 13.8977 11.6477C13.6781 11.8674 13.3219 11.8674 13.1023 11.6477L9 7.5455L4.89775 11.6477C4.67808 11.8674 4.32192 11.8674 4.10225 11.6477C3.88258 11.4281 3.88258 11.0719 4.10225 10.8523L8.60225 6.35225Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavArrowUp);
export default __webpack_public_path__ + "static/media/nav-arrow-up.fb72e949c0b7b75a4df310517ddced7c.svg";
export { ForwardRef as ReactComponent };